import(/* webpackMode: "eager" */ "/home/deploy/apps/front/src/app/forgetPassword/page.tsx");
